import POIStep from "@/components/POI/POIStep/POIStep.vue";
import {
  emailRegex,
  mapOptionDialogConfig
} from "@/configuration/formConfigurations";
import { getCoordinatesByAddress } from "@/helpers/commonHelper";
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import { checkLng, checkLat } from "@/configuration/formConfigurations";
import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import { OpenStreetMapProvider } from "leaflet-geosearch";

export default {
  name: "ContactData",
  components: { POIStep, OptionListDialog, LocationMap },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    emailRegex,
    tableOptions: {
      header: ["Name", "Längengrad", "Breitengrad"],
      content: ["displayName", "lng", "lat"],
      key: "osmId"
    },
    zoom: 17,
    differentContactAddress: false,
    locationSearchValue: ""
  }),
  async mounted() {
    if (this.isRegion)
      await this.$store.dispatch("getGlobalConfig", {
        principal: this.editedItem.principal,
        ignorePrincipal: true
      });
    else await this.$store.dispatch("getGlobalConfig");
  },
  methods: {
    async getCoordinates() {
      const res = await getCoordinatesByAddress(
        this.editedItem.address,
        this.$refs.optionDialog,
        mapOptionDialogConfig
      );
      if (res?.status) this.editedItem.geo = res.geo;
      else {
        this.snackbarText = res?.message;
        this.snackbar = true;
      }
    },
    updatePosition(geo) {
      this.editedItem.geo = geo;
    },

    changeStep(position) {
      this.$refs.map.fixLayer();
      this.$emit("changeStep", position);
    },
    checkLng,
    checkLat,
    async searchForLocation(searchValue) {
      const provider = new OpenStreetMapProvider();
      const res = await provider.search({ query: searchValue });
      if (res.length === 1) {
        const { x, y } = res[0];

        this.editedItem.geo = { lng: x, lat: y };
      } else if (res.length) {
        // Ergebnis in das richtige Format bringen
        const options = res.map(r => ({
          lng: r.x,
          lat: r.y,
          displayName: r.label,
          osmId: r.raw.osm_id
        }));
        // tableOptions ist eine Vorgabe wie der Dialog am Ende aussehen soll.
        this.$refs.optionDialog?.showDialog(options, mapOptionDialogConfig);
      } else {
        await this.$store.dispatch("createError", {
          text: "Keine Ergebnisse gefunden"
        });
      }
    }
  },
  computed: {
    globalAddress() {
      return this.$store.state.globalConfig;
    },
    isRegion() {
      return (
        this.$store.state.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    }
  }
};
